import React, { useEffect, useState } from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody
} from "@material-ui/core";
import styled from "styled-components/macro";

const StyledTable = styled(Table)`&& {
  border: 1px solid #DADCE0;
  font-family: Work Sans;
  font-weight: 300;
  width: 100vw;
}`;

const StyledTableHead = styled(TableHead)`&& {
  background-color: #FAFAFA;
  color: #5F6368;
  font-size: 16px;
  font-family: Work Sans;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0em;
}`;

const StyledTableHeadCell = styled(TableCell)`&& {
  font-family: Work Sans;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0em;
  width: 148px;
  padding: 0 1em 0 0;
}`;

const StyledTableBody = styled(TableBody)`&& {
  font-size: 14px;
  font-weight: 300;
}`;

const StyledBodyTableRow = styled(TableRow)`&& {
  background-color: #FFFFFF;
  height: 59px;
}`;

const SpacerCell = styled(TableCell)`&& {
  width: 44px;
  padding: 0;
}`;

const StyledBodyTableCell = styled(TableCell)`&& {
  font-size: 14px;
  font-family: Work Sans;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0em;
  width: 148px;
  padding: 0 1em 0 0;
}`;

const PreviewAnalysisTableCell = styled(StyledBodyTableCell)`&&{
  font-size: 14px;
  font-family: Work Sans;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: 0em;
  text-align: right;
  color:#005AA9;
  color: #005AA9;
  && > span {
    cursor: pointer;
  }
}`;

const RemoveTableCellDeal = styled(StyledBodyTableCell)`&&{
  font-size: 14px;
  font-family: Work Sans;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: 0em;
  text-align: right;
  opacity: ${({ canAddOrRemoveDeals }) => (!canAddOrRemoveDeals ? "0.25" : "")};
  color: ${({ canAddOrRemoveDeals }) => (canAddOrRemoveDeals ? "#C40A0A" : "#000000")};
  && > span {
    cursor: ${({ canAddOrRemoveDeals }) => (canAddOrRemoveDeals ? "pointer" : "")};
  }
}`;

const AddTableCell = styled(StyledBodyTableCell)`&&{
  font-size: 14px;
  font-family: Work Sans;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: 0em;
  text-align: right;
  opacity: ${({ canAddOrRemoveDeals }) => (!canAddOrRemoveDeals ? "0.25" : "")};
  color: ${({ canAddOrRemoveDeals }) => (canAddOrRemoveDeals ? "#C40A0A" : "#000000")};
  && > span {
    cursor: ${({ canAddOrRemoveDeals }) => (canAddOrRemoveDeals ? "pointer" : "")};
  }
}`;

export const EdcIndividualContactsTable = ({ headers = [], rows = [], toggleElement, openAnalysis, canAddOrRemoveDeals }) => {
  const [displayedHeaders, setDisplayedHeaders] = useState(headers);
  const [dataRows, setDataRows] = useState(rows);

  useEffect(() => {
    const propertyNames = headers.map(({ property }) => property);

    const formatter = headers.reduce((acc, header) => {
      if (header.formatter) {
        acc[header.property] = header.formatter;
      }

      return acc;
    }, {});

    const _dataRows = rows.map(row => {
      const rowData = propertyNames.map(property => (
        formatter[property] ?
          formatter[property](property, row) :
          row[property])
      );

      return {
        rowData,
        active: row.activeForCampaign,
        id: row.id
      };
    });

    setDisplayedHeaders(headers.map(({ name, headerAlignment }) => ({ name, headerAlignment })));
    setDataRows(_dataRows);
  }, [headers, rows, setDisplayedHeaders, setDataRows]);

  return (
    <StyledTable>
      <StyledTableHead>
        <TableRow>
          <SpacerCell />
          {
            displayedHeaders.map(header =>
              <StyledTableHeadCell style={{ textAlign: header.headerAlignment }} key={header.name}>
                {header.name}
              </StyledTableHeadCell>
            )
          }
          <TableCell />
          <TableCell />
          <SpacerCell />
        </TableRow>
      </StyledTableHead>
      <StyledTableBody>
        {
          dataRows.map(({ rowData = [], active, id }) => (
            <StyledBodyTableRow key={id}>
              <SpacerCell />
              {rowData.map(data => <StyledBodyTableCell key={`${data.props.children}-${id}`}>{data}</StyledBodyTableCell>)}
              {active && <PreviewAnalysisTableCell><span onClick={() => openAnalysis(id)}>Preview Analysis</span></PreviewAnalysisTableCell>}
              {!active && <AddTableCell canAddOrRemoveDeals={canAddOrRemoveDeals} />}
              {!active && <AddTableCell canAddOrRemoveDeals={canAddOrRemoveDeals}>
                {" "}
                <span onClick={() => ((canAddOrRemoveDeals) ? toggleElement(id) : null)}>Add Back</span>
              </AddTableCell>}
              {
                active &&
                <RemoveTableCellDeal canAddOrRemoveDeals={canAddOrRemoveDeals}>
                  <span onClick={() => ((canAddOrRemoveDeals) ? toggleElement(id) : null)}>Remove Deal</span>
                </RemoveTableCellDeal>
              }
              <SpacerCell />
            </StyledBodyTableRow>
          ))
        }
      </StyledTableBody>
    </StyledTable>
  );
};
